import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import { getLocales } from 'assets/locales/Locale';
import BigHr from 'assets/templates/dividers/BigHr';
import Theme from 'assets/themes/Theme.Common';
import { combineStrings } from 'assets/utils/data/String';
import ClaimJobStatusStateMachine from 'module/claims/components/claimJobStateMachine/ClaimJob.StatusStateMachine';
import { useClaimEdit } from '../ClaimEdit.Hooks';
import ClaimEditJobComments from './claimJobEdit/ClaimEdit.Job.Comments';
import ClaimEditJobDelete from './claimJobEdit/ClaimEdit.Job.Delete';
import ClaimEditJobDocuments from './claimJobEdit/ClaimEdit.Job.Documents';
import ClaimEditJobEmailTemplate from './claimJobEdit/ClaimEdit.Job.EmailTemplate';
import { ClaimJobEditProvider } from './claimJobEdit/ClaimEdit.Job.Hooks';
import ClaimEditJobInfo from './claimJobEdit/ClaimEdit.Job.Info';
import ClaimEditJobSubmitButton from './claimJobEdit/ClaimEdit.Job.SubmitButton';
import ClaimEditJobItems from './claimJobEdit/claimJobEditItem/ClaimEdit.Job.Items';
import ClaimEditJobForm from './claimJobEdit/claimJobForm/ClaimEdit.Job.Form';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import Card from 'assets/components/card/Card';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import Box from 'assets/components/box/Box';

export default function ClaimEditJobs() {
  const { lang } = getLocales();
  const { claim, product } = useClaimEdit();

  return (
    <>
      <div style={{ marginLeft: Theme.Size.XL, marginRight: Theme.Size.XL }}>
        {!claim?.claimJobs?.length && <h2>{lang.jobs}</h2>}
        {!claim?.claimJobs?.length && <ErrorWrapper children={lang.noJobs} />}
      </div>
      {!!claim?.claimJobs?.length && (
        <DataMap
          data={claim?.claimJobs}
          render={({ data: job, isFirst }) => {
            return (
              <ClaimJobEditProvider
                key={job.id}
                claimJobId={job.id}
                render={({
                  claimTypeReport,
                  setAction,
                  claimJob,
                  action,
                  permissions,
                  isClaimAdmin,
                  isClaimJobEditableByStatus,
                  hasAnyClaimJobPermission,
                  canViewClaimJobComments,
                  canViewClaimJobItems,
                  canViewClaimJobDocuments,
                  isStatusChanged,
                  statusInfo,
                  changeJobStatusForm,
                  emailTemplates,
                  currentStatus,
                  setEmailAction,
                  setIsforStatusChange,
                  emailAction,
                  isClaimOwner,
                  isCreatedAutomatically,
                }) => {
                  return (
                    claimJob && (
                      <>
                        {changeJobStatusForm.data?.claimJobEmailTemplate && emailAction === 'changeStatusSendEmail' && (
                          <ClaimEditJobEmailTemplate />
                        )}
                        {!isFirst && <BigHr />}
                        <div id={`${lang.job}-${claimJob.id}`}>
                          <Card
                            class={ThemeCardRow}
                            style={{
                              gap: Theme.Size.L,
                              backgroundColor: 'var(--colorPrimary)',
                              color: 'var(--colorBackground)',
                              padding: Theme.Size.XS,
                            }}
                            media={<Icon class="fas-car-crash" />}
                            subtitle={
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  margin: Theme.Size.S,
                                }}
                              >
                                <h1>
                                  {combineStrings(
                                    '-',
                                    product?.category?.code,
                                    claim?.id?.toString(),
                                    `J${job.jobNumber}`
                                  )}
                                </h1>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <h1 style={{ margin: 0 }}>{claimJob?.authorizationNumber}</h1>
                                  {isCreatedAutomatically && (
                                    <>
                                      <br />
                                      <Box
                                        class={ThemeTagRounded}
                                        style={{
                                          backgroundColor: Theme.Color.success,
                                          fontSize: Theme.FontSize.S,
                                        }}
                                      >
                                        {lang.automation.toUpperCase()}
                                      </Box>
                                    </>
                                  )}
                                  {/*  TODO: Add when needed! {!claimTypeReport && <ClaimEditJobAggregateInfo />} */}
                                  {claimJob.claimType && (
                                    <>
                                      <br />
                                      <h1 style={{ margin: 0 }}>{claimJob.claimType?.displayInfo?.title}</h1>
                                    </>
                                  )}
                                </div>
                                <h1 style={{ margin: 0 }}>{claimJob.statusCode?.replace(/_/g, ' - ')}</h1>
                              </div>
                            }
                          />
                          <div
                            style={{
                              marginLeft: Theme.Size.XL,
                              marginRight: Theme.Size.XL,
                              justifyContent: (isClaimAdmin || hasAnyClaimJobPermission) && 'space-between',
                            }}
                          >
                            <ClaimEditJobInfo />
                            {!(isClaimAdmin || (isClaimOwner && permissions?.EDIT_CLAIMJOB)) ||
                              (!isClaimJobEditableByStatus && action === 'edit' && <ClaimEditJobForm />)}
                            {!(isClaimAdmin || (isClaimOwner && permissions?.DELETE_CLAIMJOB)) ||
                              (!isClaimJobEditableByStatus && action === 'delete' && <ClaimEditJobDelete />)}
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: Theme.Size.S,
                                marginTop: Theme.Size.L,
                              }}
                            >
                              <>
                                {action === 'compressed' ? (
                                  <Button
                                    onClick={setAction}
                                    data="expanded"
                                    media={<Icon class="fas-chevron-down" />}
                                    render={lang.viewMore}
                                    class={ThemeButtonCircle}
                                    htmlElementProps={{ title: lang.viewMore }}
                                  />
                                ) : (
                                  <Button
                                    onClick={setAction}
                                    data="compressed"
                                    media={<Icon class="fas-chevron-up" />}
                                    render={lang.viewLess}
                                    class={ThemeButtonCircle}
                                    htmlElementProps={{ title: lang.viewLess }}
                                  />
                                )}
                                <Button
                                  onClick={setAction}
                                  data="edit"
                                  media={<Icon class="fas-edit" />}
                                  render={lang.edit}
                                  class={ThemeButtonCircle}
                                  disabled={
                                    isClaimJobEditableByStatus ||
                                    !(isClaimAdmin || (isClaimOwner && permissions?.EDIT_CLAIMJOB))
                                  }
                                  htmlElementProps={{ title: lang.edit }}
                                />
                                <ClaimJobStatusStateMachine
                                  emailTemplates={emailTemplates}
                                  statusInfo={statusInfo}
                                  disabled={!(isClaimAdmin || (isClaimOwner && permissions?.UPDATE_CLAIMJOB_STATUS))}
                                  isStatusChanged={isStatusChanged}
                                  ownerId={changeJobStatusForm.data?.ownerId}
                                  currentStatus={currentStatus}
                                  changeStatus={changeJobStatusForm}
                                  setEmailAction={setEmailAction}
                                  setIsforStatusChange={setIsforStatusChange}
                                />
                                <Button
                                  onClick={setAction}
                                  data="delete"
                                  media={<Icon class="fas-trash" />}
                                  render={lang.delete}
                                  class={ThemeButtonCircle}
                                  disabled={
                                    isClaimJobEditableByStatus ||
                                    !(isClaimAdmin || (isClaimOwner && permissions?.DELETE_CLAIMJOB))
                                  }
                                  htmlElementProps={{ title: lang.delete }}
                                />
                                <ClaimEditJobSubmitButton />
                              </>
                            </div>
                          </div>
                        </div>
                        {action !== 'compressed' && (
                          <>
                            {canViewClaimJobDocuments && (
                              <>
                                <br />
                                <hr />
                                <ClaimEditJobDocuments />
                              </>
                            )}
                            {canViewClaimJobItems && (
                              <>
                                {!claimTypeReport && <ClaimEditJobItems />}
                                <br />
                                <hr />
                              </>
                            )}
                            {canViewClaimJobComments && <ClaimEditJobComments />}
                          </>
                        )}
                      </>
                    )
                  );
                }}
              />
            );
          }}
        />
      )}
    </>
  );
}
